<template>
    <div>
        <menu-bar></menu-bar>
        <div style="margin-top: 60px"></div>
        <div class="container">
            <div class="row">

                <div style="text-align: center;">
                    <img src="image/logo2.png">
                </div>

                <div class="main" v-if="nome">

                    <br/><br/>

                    <h5>Olá, <b>{{ nome }}</b></h5>

                    <br/>

                    <form role="form">
                        <div class="form-group">
                            <label for="senha1">SENHA</label>
                            <input v-model="data.senha1" autocomplete="0" type="password" class="form-control" id="senha1">
                        </div>
                        <div class="form-group">
                            <label for="senha2">REPITA A SENHA</label>
                            <input v-model="data.senha2" autocomplete="0" type="password" class="form-control" id="senha2">
                        </div>
                        <button :disabled="!itsOk" @click="auth()" type="button" class="btn btn btn-info btn-block">
                            CADASTRAR NOVA SENHA
                        </button>
                    </form>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { Usuario } from "../class/index";

export default {
    data() {
        return {
            data: {
                senha1: "",
                senha2: "",
                token: null
            },
            nome: null
        };
    },
    computed: {
        itsOk: function() {
            if (!this.data.senha1) {
                return false;
            } else if (!this.data.senha2) {
                return false;
            } else if (this.data.senha2 !== this.data.senha1) {
                return false;
            }
            return true;
        }
    },
    beforeMount() {
        if (this.$route.params.token) {
            this.data.token = this.$route.params.token;
            Usuario.getByToken(this.$route.params.token)
                .then(data => (this.nome = data.nome))
                .catch(() => {
                    this.$router.push("/login");
                });
        }
    },
    methods: {
        auth() {
            Usuario.updatePasswordByToken(this.data)
                .then(() => {
                    // eslint-disable-next-line no-undef
                    swal("Usuário", "Senha Alterada com sucesso", "success");
                    this.$router.push("/login");
                })
                .catch(() => {
                    // eslint-disable-next-line no-undef
                    return swal(
                        "Usuário",
                        "Problemas para alterar a senha!",
                        "error"
                    );
                });
        }
    }
};
</script>
<style>
body {
    padding-top: 15px;
    font-size: 12px;
}
.main {
    max-width: 320px;
    margin: 0 auto;
}
h3 {
    text-align: center;
    line-height: 300%;
}
</style>
